import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { useAmbassadorProgramEnabled } from "@/hooks/useAmbassadorProgramEnabled";
import { useUpPromoteJoinEnabled } from "@/hooks/useUpPromoteJoinEnabled";
import { useIsAdmin } from "@/hooks/useIsAdmin";
import { useLocale } from "@/contexts/LocaleContext";
import { SiteShell } from "@/components/SiteShell";
import { UpPromoteJoinPage } from "@/components/ambassador/UpPromoteJoinPage";

// صفحات تابعة لتسجيل UpPromote تعمل بغضّ النظر عن البرنامج المحلّيّ.
const UPPROMOTE_PATHS = ["/ambassadors/joined", "/ambassadors/join-terms"];

function JoinUnavailable() {
  const { t, dir } = useLocale();
  return (
    <SiteShell>
      <div className="mx-auto max-w-xl px-4 py-16 text-center" dir={dir}>
        <p className="text-sm text-muted-foreground">{t("upjoin.err.unavailable")}</p>
      </div>
    </SiteShell>
  );
}

function AmbassadorsLayout() {
  const joinOn = useUpPromoteJoinEnabled();
  const { isAdmin } = useIsAdmin();
  const oldOn = useAmbassadorProgramEnabled();
  const { pathname } = useLocation();
  // كلّ مسارات التسجيل محكومة بـ uppromote_join_enabled؛ الأدمن يرى دائماً للاختبار.
  if (joinOn !== true && isAdmin !== true) return <JoinUnavailable />;
  if (oldOn || UPPROMOTE_PATHS.some((p) => pathname.startsWith(p))) return <Outlet />;
  return <UpPromoteJoinPage />;
}

export const Route = createFileRoute("/ambassadors")({
  component: AmbassadorsLayout,
});
